import React from "react";

const Loader = () => {
  return (
    <div
      className=" d-flex  align-items-center justify-content-center"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "hsla(341, 0%, 0%, 0.1)",
        zIndex: 9999, /* Increase the z-index to a higher value */
      }}
    >
      <div
        class="spinner-border"
        style={{ width: "6rem", height: "6rem" }}
        role="status"
      >
        {/* <span class="visually-hidden">Loading...</span> */}
      </div>
    </div>
  );
};

export default Loader;
